"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const applicator_1 = require("./applicator");
const consts_1 = require("./consts");
const is_proxy_1 = require("./is_proxy");
const target_1 = require("./target");
const utils_1 = require("./utils");
/* DESTRUCTURING */
const { isArray } = Array, { getOwnPropertyDescriptor } = Object, { apply, defineProperty, deleteProperty, get, set } = Reflect, { execute } = applicator_1.default, { isEqual, isLooselyImmutableArrayMethod, isStrictlyImmutableMethod, isValueUnproxiable } = utils_1.default;
/* TRAPS HELPERS */
const Traps = {
    get(target, property, receiver) {
        if (property === 'constructor')
            return target.constructor;
        if (typeof property === 'symbol') {
            if (property === consts_1.$TARGET)
                return target;
            if (property === consts_1.$GET_RECORD_START)
                return this.getPathsRecording = true;
            if (property === consts_1.$GET_RECORD_STOP) {
                const paths = this.getPaths;
                this.getPathsRecording = false;
                this.getPaths = [];
                return paths;
            }
            if (property === consts_1.$IS_PROXY)
                return true;
            if (property === consts_1.$STOP) {
                this.stopped = true;
                this.changedPaths = undefined; //TSC
                this.paths = undefined; //TSC
                return target;
            }
            const value = get(target, property, receiver);
            if (typeof value === 'function')
                return value.bind(target); //FIXME: Binding here prevents the function to be potentially re-bounded later
            return value;
        }
        receiver = receiver[consts_1.$TARGET] || receiver;
        if (this.getPathsRecording && !this.getParentPath(target))
            this.getPaths.push(property); // We are only recording root paths, because I don't see a use case for recording deeper paths too //TSC
        const value = get(target, property, receiver);
        if (this.stopped || isValueUnproxiable(value))
            return value;
        const descriptor = getOwnPropertyDescriptor(target, property);
        if (descriptor && !descriptor.configurable && !descriptor.writable)
            return value; // Preserving invariants
        if (typeof value === 'function' && isStrictlyImmutableMethod(value))
            return value.bind(target); //FIXME: Binding here prevents the function to be potentially re-bounded later
        this.setChildPath(target, value, property);
        if (consts_1.IS_DEVELOPMENT)
            this.checkChildIsRoot(value);
        const proxyCached = this.proxies.get(value);
        if (proxyCached)
            return proxyCached;
        const proxy = new Proxy(value, this.traps);
        this.proxies.set(value, proxy);
        return proxy;
    },
    set(target, property, value, receiver) {
        value = target_1.default(value);
        if (this.stopped || typeof property === 'symbol')
            return set(target, property, value, receiver);
        receiver = receiver[consts_1.$TARGET] || receiver;
        const isValueUndefined = (value === undefined), didPropertyExist = isValueUndefined && property in target, isValueUndefinedNew = (isValueUndefined && !didPropertyExist), prev = !isValueUndefinedNew && get(target, property, receiver), result = set(target, property, value, receiver), changed = result && (isValueUndefinedNew || !isEqual(prev, value));
        return changed ? this.triggerChange(result, this.getChildPath(target, property)) : result;
    },
    defineProperty(target, property, descriptor) {
        if (this.stopped || typeof property === 'symbol')
            return defineProperty(target, property, descriptor);
        const prev = getOwnPropertyDescriptor(target, property), changed = defineProperty(target, property, descriptor);
        if (changed) {
            const next = Object.assign({ configurable: false, enumerable: false, writable: false }, descriptor); // Accounting for defaults
            if (isEqual(prev, next))
                return true;
        }
        return changed ? this.triggerChange(changed, this.getChildPath(target, property)) : changed;
    },
    deleteProperty(target, property) {
        if (!(property in target))
            return true;
        const changed = deleteProperty(target, property);
        if (this.stopped || typeof property === 'symbol')
            return changed;
        return changed ? this.triggerChange(changed, this.getChildPath(target, property)) : changed;
    },
    apply(target, thisArg, args) {
        if (!is_proxy_1.default(thisArg))
            return apply(target, thisArg, args);
        const isArrayThis = isArray(thisArg);
        if (this.stopped || (isArrayThis && isLooselyImmutableArrayMethod(target)))
            return apply(target, thisArg, args);
        const thisArgTarget = (isArrayThis ? thisArg[consts_1.$TARGET] : target_1.default(thisArg));
        if (!isArrayThis)
            thisArg = thisArgTarget;
        const [result, changed] = execute(target, thisArg, thisArgTarget, args);
        return changed ? this.triggerChange(result, this.getParentPath(thisArgTarget)) : result;
    }
};
/* EXPORT */
exports.default = Traps;
